var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 12,
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M9.9,0.6H2.1c-0.8,0-1.5,0.7-1.5,1.5v7.8c0,0.8,0.7,1.5,1.5,1.5h7.8c0.8,0,1.5-0.7,1.5-1.5V2.1 C11.4,1.3,10.7,0.6,9.9,0.6z M8.9,3.9h1.7v1.7H8.9V3.9z M8.1,5.6H3.9V1.4h4.2V5.6z M3.1,5.6H1.4V3.9h1.7V5.6z M1.4,6.4h1.7v1.7H1.4 V6.4z M3.9,6.4h4.2v4.2H3.9V6.4z M8.9,6.4h1.7v1.7H8.9V6.4z M10.6,2.1v1H8.9V1.4h1C10.3,1.4,10.6,1.7,10.6,2.1z M2.1,1.4h1v1.7H1.4 v-1C1.4,1.7,1.7,1.4,2.1,1.4z M1.4,9.9v-1h1.7v1.7h-1C1.7,10.6,1.4,10.3,1.4,9.9z M9.9,10.6h-1V8.9h1.7v1 C10.6,10.3,10.3,10.6,9.9,10.6z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideos);
export default __webpack_public_path__ + "static/media/videos.69ed0a99d01dcd4225a92f68755f8b2e.svg";
export { ForwardRef as ReactComponent };